/* eslint-disable react/no-unescaped-entities */
import React, { memo, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Table, Checkbox, Select } from 'antd';
import { ticketColumnConfig } from './ticket.config';
import { Button, PopAlert } from 'appkit-react';
import { API } from '@service';
import { Loading } from '@components';
import moment from 'moment';
// import '@style/components/ddTable.scss';
// import '@style/modules/ticket.scss';
import '../../styles/components/ddTable.scss';
import '../../styles/modules/ticket.scss';
import { handleNameInitialsModuleBack } from '@utils/history';
let formData = [];
function TicketList({ adminList, userInfo }) {
  const { Option } = Select;
  const [rowId, setRowId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [issueList, setIssueList] = useState();
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPage: 0,
  });
  const history = useHistory();

  const buildRequestBy = (name, email) => (
    <div className="width-130">
      <div className="user-name ellipse">{name}</div>
      <div className="user-email ellipse">{email}</div>
    </div>
  );

  const onSelectChange = (e, issue) => {
    const obj = {
      _id: issue._id,
      assignee: e,
    };
    if (formData.findIndex((item) => item._id === issue._id) === -1) {
      formData.push(obj);
    } else {
      Object.assign(
        formData[formData.findIndex((item) => item._id === issue._id)],
        obj,
      );
    }
  };

  const onCheckBoxChange = (e, issue) => {
    const obj = {
      _id: issue._id,
      status: e.target.checked ? 'resolved' : 'open',
    };
    if (formData.findIndex((item) => item._id === issue._id) === -1) {
      formData.push(obj);
    } else {
      Object.assign(
        formData[formData.findIndex((item) => item._id === issue._id)],
        obj,
      );
    }
  };
  const formatTicketNo = (s) => `00000${s}`.substring(String(s).length);
  const fetchAndFormatData = async (currentPage) => {
    setIsLoading(true);
    const pageData = await API.getIssueList(currentPage);
    const list = pageData.list;
    setPagination({
      currentPage,
      totalPage: pageData.total,
    });
    // cache data for selected or chekced options
    formData.forEach((e) => {
      const itemIndexInList = list.findIndex((item) => item._id === e._id);
      if (itemIndexInList !== -1) {
        const obj = {};
        if (e.assignee || e.assignee === '') {
          obj.assignee = e.assignee;
        }
        if (e.status) {
          obj.status = e.status;
        }
        list[itemIndexInList] = {
          ...list[itemIndexInList],
          ...obj,
        };
      }
    });
    const formattedIssueList = list?.map((item, index) => {
      const formattedIssue = {
        ...item,
        ticketNo: formatTicketNo(item.ticketNo),
        createdDate: moment(item.createAt).format('MM/DD/YYYY'),
        requestBy: buildRequestBy(item.reporterName, item.reporterEmail),
        decription: <div className="desc">{item.description}</div>,
        resolved: (
          // <Form.Item key={`checkbox-${index}`}>
          <Checkbox
            key={`checkbox-${index}`}
            defaultChecked={item.status === 'resolved'}
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => {
              onCheckBoxChange(e, item);
            }}
          />
          // </Form.Item>
        ),
        assignedTo: (
          // <Form.Item key={`select-${index}`}>
          <Select
            key={`select-${index}`}
            style={{ width: 160 }}
            placeholder="Select a person"
            defaultValue={
              adminList.find((admin) => admin.guid === item.assignee)?.fullName
            }
            onChange={(e) => {
              onSelectChange(e, item);
            }}
            onClick={(e) => {
              e.stopPropagation();
            }}
            dropdownClassName="ticket-dropdown"
          >
            <Option key="guid-none" value="" />
            {adminList?.map((admin) => (
              <Option key={admin.guid} value={admin.guid}>
                {admin.fullName}
              </Option>
            ))}
          </Select>
          // </Form.Item>
        ),
        followUp: item.enableNotification ? 'Y' : 'N',
      };
      return formattedIssue;
    });
    setIssueList(formattedIssueList);
    setIsLoading(false);
  };

  useEffect(() => {
    (async () => {
      if (adminList) {
        await fetchAndFormatData(pagination.currentPage);
      }
    })();
  }, [adminList]);
  useEffect(
    () => () => {
      formData = [];
    },
    [],
  );
  const saveData = async (e) => {
    setIsSaving(true);
    const result = await API.updateIssue(formData);
    setIsSaving(false);
    if (result.success) {
      PopAlert({
        className: 'success-message-popover',
        oneLineDisplay: true,
        duration: 2000,
        status: 'success',
        message: 'SAVED SUCCESSFULLY',
      });
      history.goBack();
    }
    // history.goBack();
  };

  const onPageChange = async (e) => {
    await fetchAndFormatData(e);
  };

  return isLoading ? (
    <Loading style={{ position: 'absolute', top: '50%', left: '50%' }} />
  ) : (
    <div className="ticket-page">
      <span
        className="dd-back-btn"
        onClick={() => handleNameInitialsModuleBack(history)}
      >
        <span className="appkiticon icon-left-chevron-fill a-font-12" /> Back
      </span>
      <div className="page-title">Issue List</div>
      <Table
        columns={ticketColumnConfig}
        dataSource={issueList}
        className="dd-table"
        pagination={{
          className: 'ticket-pagination',
          position: ['bottomLeft'],
          simple: true,
          total: pagination.totalPage,
          current: pagination.currentPage,
          onChange: onPageChange,
        }}
        onRow={(record) => ({
          onClick: (e) => {
            setRowId(rowId === record.ticketNo ? null : record.ticketNo);
          },
        })}
        rowClassName={(record) => (rowId === record.ticketNo ? 'expand' : '')}
      />
      <div className="button-area">
        <Button
          size="lg"
          kind="secondary"
          onClick={history.goBack}
          isLoading={isSaving}
        >
          cancel
        </Button>
        <Button
          size="lg"
          kind="primary"
          isLoading={isSaving}
          onClick={() => {
            saveData();
          }}
        >
          save
        </Button>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => ({
  userInfo: state.login.userInfo,
  adminList: state.common.config.adminList,
});
export default connect(mapStateToProps)(memo(TicketList));
